// Thin client wrapper around the contact form transport. Currently posts to
// Formspree via REACT_APP_FORMSPREE_ID. Keeps the contact form decoupled
// from transport details — if we ever swap providers again we touch only
// this file.

const FORMSPREE_ID = process.env.REACT_APP_FORMSPREE_ID || '';

export const CONTACT_ENDPOINT = FORMSPREE_ID
  ? `https://formspree.io/f/${FORMSPREE_ID}`
  : '';

export async function postContact(payload) {
  if (!CONTACT_ENDPOINT) {
    throw new Error(
      'Contact form is not configured. Set REACT_APP_FORMSPREE_ID in the environment.'
    );
  }

  const response = await fetch(CONTACT_ENDPOINT, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
    body: JSON.stringify(payload),
  });

  let data = null;
  try {
    data = await response.json();
  } catch {
    data = null;
  }

  // Formspree returns { ok: true } on success and { errors: [...] } on failure.
  const ok = response.ok && (data?.ok === true || data?.success === true);
  if (!ok) {
    const message =
      data?.error ||
      (Array.isArray(data?.errors) && data.errors[0]?.message) ||
      `Request failed with status ${response.status}`;
    throw new Error(message);
  }
  return data;
}
